import React, { useState, useEffect } from "react";
import "./ClienteForm.css";

const DEFAULT_OPTIONS = {
  usoCfdiOptions: [
    { value: "G01", label: "Adquisición de mercancias" },
    { value: "G02", label: "Devoluciones, descuentos o bonificaciones" },
    { value: "G03", label: "Gastos en general" },
    { value: "I01", label: "Construcciones" },
    { value: "I02", label: "Mobiliario y equipo de oficina por inversiones" },
    { value: "I03", label: "Equipo de transporte" },
    { value: "I04", label: "Equipo de cómputo y accesorios" },
    { value: "I05", label: "Dados, troqueles, moldes, matrices y herramental" },
    { value: "I06", label: "Comunicaciones telefónicas" },
    { value: "I07", label: "Comunicaciones satelitales" },
    { value: "I08", label: "Otra maquinaria y equipo" },
    { value: "D01", label: "Honorarios médicos, dentales y gastos hospitalarios" },
    { value: "D02", label: "Gastos médicos por incapacidad o discapacidad" },
    { value: "D03", label: "Gastos funerales" },
    { value: "D04", label: "Donativos" },
    { value: "D05", label: "Intereses reales por créditos hipotecarios (casa habitación)" },
    { value: "D06", label: "Aportaciones voluntarias al SAR" },
    { value: "D07", label: "Primas por seguros de gastos médicos" },
    { value: "D08", label: "Gastos de transportación escolar obligatoria" },
    { value: "D09", label: "Depósitos en cuentas para el ahorro y planes de pensiones" },
    { value: "D10", label: "Pagos por servicios educativos (colegiaturas)" },
    { value: "S01", label: "Sin efectos fiscales" },
    { value: "CP01", label: "Pagos" },
    { value: "CN01", label: "Nómina" },
    { value: "P01", label: "Por definir" },
  ],
  metodoPagoOptions: [
    { value: "PUE", label: "Pago en una sola exhibición" },
    { value: "PPD", label: "Pago en parcialidades o diferido" },
  ],
  claveFormaPagoOptions: [
    { value: "01", label: "Efectivo" },
    { value: "02", label: "Cheque nominativo" },
    { value: "03", label: "Transferencia electrónica de fondos" },
    { value: "04", label: "Tarjeta de crédito" },
    { value: "05", label: "Monedero electrónico" },
    { value: "06", label: "Dinero electrónico" },
    { value: "08", label: "Vales de despensa" },
    { value: "12", label: "Dación en pago" },
    { value: "13", label: "Pago por subrogación" },
    { value: "14", label: "Pago por consignación" },
    { value: "15", label: "Condonación" },
    { value: "17", label: "Compensación" },
    { value: "23", label: "Novación" },
    { value: "24", label: "Confusión" },
    { value: "25", label: "Remisión de deuda" },
    { value: "26", label: "Prescripción o caducidad" },
    { value: "27", label: "A satisfacción del acreedor" },
    { value: "28", label: "Tarjeta de débito" },
    { value: "29", label: "Tarjeta de servicios" },
    { value: "30", label: "Aplicación de anticipos" },
    { value: "31", label: "Intermediario pagos" },
    { value: "99", label: "Por definir" },
  ],
  regimenOptions: [
    { value: "601", label: "General de Ley Personas Morales" },
    { value: "603", label: "Personas Morales con Fines no Lucrativos" },
    { value: "605", label: "Sueldos y Salarios e Ingresos Asimilados a Salarios" },
    { value: "606", label: "Arrendamiento" },
    { value: "607", label: "Régimen de Enajenación o Adquisición de Bienes" },
    { value: "608", label: "Demás ingresos" },
    { value: "610", label: "Residentes en el Extranjero sin Establecimiento Permanente en México" },
    { value: "611", label: "Ingresos por Dividendos (socios y accionistas)" },
    { value: "612", label: "Personas Físicas con Actividades Empresariales y Profesionales" },
    { value: "614", label: "Ingresos por intereses" },
    { value: "615", label: "Régimen de los ingresos por obtención de premios" },
    { value: "616", label: "Sin obligaciones fiscales" },
    { value: "620", label: "Sociedades Cooperativas de Producción que optan por diferir sus ingresos" },
    { value: "621", label: "Incorporación Fiscal" },
    { value: "622", label: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras" },
    { value: "623", label: "Opcional para Grupos de Sociedades" },
    { value: "624", label: "Coordinados" },
    { value: "625", label: "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas" },
    { value: "626", label: "Régimen Simplificado de Confianza" },
  ],
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validateEmails = (value) => {
  if (!value) return "";
  const parts = value.split(";").map((s) => s.trim()).filter(Boolean);
  const invalid = parts.filter((p) => !EMAIL_REGEX.test(p));
  return invalid.length > 0
    ? `Correo(s) inválido(s): ${invalid.join(", ")}`
    : "";
};

const ClienteForm = ({ clienteInicial, onSubmit }) => {
  const [emailError, setEmailError] = useState("");
  const [cliente, setCliente] = useState({
    ID: null,
    clave: "",
    rfc: "",
    nombre: "",
    NombreFiscal: "",
    direccion: "",
    colonia: "",
    ciudad: "",
    estado: "",
    cp: "",
    email: "",
    emailCxP: "",
    estatus: "A",
    telefono: "",
    delegacion: "",
    mododepago: "",
    cuenta_bancaria: "",
    impuestos: false,
    TIPO_CARTERA: 1,
    claveformapago: "99",
    usocfdi: "P01",
    metodopago: "PPD",
    claveformapagoparacomplemento: "",
    Regimen: "",
    diasCredito: 0,
  });

  const options = DEFAULT_OPTIONS;

  useEffect(() => {
    if (clienteInicial && Object.keys(clienteInicial).length > 0) {
      const updatedCliente = {
        ID: clienteInicial.ID ?? clienteInicial.id ?? null,
        clave: clienteInicial.clave ?? "",
        rfc: clienteInicial.rfc ?? "",
        nombre: clienteInicial.nombre ?? "",
        NombreFiscal:
          clienteInicial.NombreFiscal ?? clienteInicial.nombreFiscal ?? "",
        direccion: clienteInicial.direccion ?? "",
        colonia: clienteInicial.colonia ?? "",
        ciudad: clienteInicial.ciudad ?? "",
        estado: clienteInicial.estado ?? "",
        cp: clienteInicial.cp ?? "",
        email: clienteInicial.email ?? "",
        emailCxP: clienteInicial.emailCxP ?? clienteInicial.EmailCxP ?? "",
        estatus: clienteInicial.estatus ?? "A",
        telefono: clienteInicial.telefono ?? "",
        delegacion: clienteInicial.delegacion ?? "",
        mododepago:
          clienteInicial.modoDePago ?? clienteInicial.mododepago ?? "",
        cuenta_bancaria:
          clienteInicial.cuenta_Bancaria ??
          clienteInicial.cuenta_bancaria ??
          "",
        impuestos: clienteInicial.impuestos ?? false,
        TIPO_CARTERA:
          clienteInicial.TIPO_CARTERA ?? clienteInicial.tipo_Cartera ?? 1,
        claveformapago:
          clienteInicial.claveFormaPago ??
          clienteInicial.claveformapago ??
          "99",
        usocfdi: clienteInicial.usoCfdi ?? clienteInicial.usocfdi ?? "P01",
        metodopago:
          clienteInicial.metodoPago ?? clienteInicial.metodopago ?? "PPD",
        claveformapagoparacomplemento:
          clienteInicial.claveFormaPagoParaComplemento ??
          clienteInicial.claveformapagoparacomplemento ??
          "",
        Regimen: clienteInicial.Regimen ?? clienteInicial.regimen ?? "",
        diasCredito: Number(
          clienteInicial.diasCredito ?? clienteInicial.DiasCredito ?? 0,
        ), // ← CAMBIO AQUÍ
      };
      setCliente(updatedCliente);
    }
  }, [clienteInicial]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCliente((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validateEmails(cliente.email);
    if (error) {
      setEmailError(error);
      return;
    }
    const clienteToSubmit = {
      ...cliente,
      ID: cliente.ID ?? clienteInicial?.ID ?? clienteInicial?.id ?? null,
    };
    onSubmit(clienteToSubmit);
  };

  return (
    <form onSubmit={handleSubmit} className="cliente-form">
      <input type="hidden" name="ID" value={cliente.ID ?? ""} />

      {/* Datos Generales */}
      <div className="section">
        <h3 className="section-title">Datos Generales</h3>
        <div className="grid">
          <div className="field-group">
            <label className="label">Clave:</label>
            <input
              className="input"
              type="text"
              name="clave"
              value={cliente.clave}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label className="label">RFC:</label>
            <input
              className="input"
              type="text"
              name="rfc"
              value={cliente.rfc}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label className="label">Nombre:</label>
            <input
              className="input"
              type="text"
              name="nombre"
              value={cliente.nombre}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label className="label">Nombre Fiscal:</label>
            <input
              className="input"
              type="text"
              name="NombreFiscal"
              value={cliente.NombreFiscal}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* Dirección */}
      <div className="section">
        <h3 className="section-title">Dirección</h3>
        <div className="grid">
          <div className="field-group">
            <label className="label">Dirección:</label>
            <input
              className="input"
              type="text"
              name="direccion"
              value={cliente.direccion}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label className="label">Colonia:</label>
            <input
              className="input"
              type="text"
              name="colonia"
              value={cliente.colonia}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label className="label">Ciudad:</label>
            <input
              className="input"
              type="text"
              name="ciudad"
              value={cliente.ciudad}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label className="label">Estado:</label>
            <input
              className="input"
              type="text"
              name="estado"
              value={cliente.estado}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label className="label">Código Postal:</label>
            <input
              className="input"
              type="text"
              name="cp"
              value={cliente.cp}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* Contacto y Estatus */}
      <div className="section">
        <h3 className="section-title">Contacto y Estatus</h3>
        <div className="grid">
          <div className="field-group">
            <label className="label">Email:</label>
            <input
              className={`input${emailError ? " input-error" : ""}`}
              type="text"
              name="email"
              maxLength={250}
              value={cliente.email}
              onChange={(e) => {
                handleChange(e);
                setEmailError(validateEmails(e.target.value));
              }}
              placeholder="correo1@empresa.com;correo2@empresa.com"
            />
            {emailError && <span className="field-error">{emailError}</span>}
          </div>
          <div className="field-group">
            <label className="label">Email Cuentas por Pagar:</label>
            <input
              className="input"
              type="text"
              name="emailCxP"
              maxLength={250}
              value={cliente.emailCxP}
              onChange={handleChange}
              placeholder="cxp@cliente.com;otro@cliente.com"
            />
          </div>
          <div className="field-group">
            <label className="label">Teléfono:</label>
            <input
              className="input"
              type="text"
              name="telefono"
              value={cliente.telefono}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label className="label">Estatus:</label>
            <select
              className="input"
              name="estatus"
              value={cliente.estatus}
              onChange={handleChange}
            >
              <option value="A">Activo</option>
              <option value="I">Inactivo</option>
            </select>
          </div>
          <div className="field-group">
            <label className="label">Delegación:</label>
            <input
              className="input"
              type="text"
              name="delegacion"
              value={cliente.delegacion}
              onChange={handleChange}
            />
          </div>

          <div className="field-group">
            <label className="label">Dias Credito:</label>
            <input
              className="input"
              type="number"
              name="diasCredito"
              value={cliente.diasCredito}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* Datos de Pago */}
      <div className="section">
        <h3 className="section-title">Datos de Pago</h3>
        <div className="grid">
          <div className="field-group">
            <label className="label">Modo de Pago:</label>
            <input
              className="input"
              type="text"
              name="mododepago"
              value={cliente.mododepago}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label className="label">Cuenta Bancaria:</label>
            <input
              className="input"
              type="text"
              name="cuenta_bancaria"
              value={cliente.cuenta_bancaria}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label className="label">Impuestos:</label>
            <input
              className="checkbox"
              type="checkbox"
              name="impuestos"
              checked={cliente.impuestos}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label className="label">Tipo Cartera:</label>
            <input
              className="input"
              type="number"
              name="TIPO_CARTERA"
              value={cliente.TIPO_CARTERA}
              onChange={handleChange}
            />
          </div>

          <div className="field-group">
            <label className="label">Clave Forma de Pago:</label>
            <select
              className="input"
              name="claveformapago"
              value={cliente.claveformapago}
              onChange={handleChange}
            >
              <option value="">Selecciona...</option>
              {options.claveFormaPagoOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.value} - {o.label}
                </option>
              ))}
            </select>
          </div>

          <div className="field-group">
            <label className="label">Uso CFDI:</label>
            <select
              className="input"
              name="usocfdi"
              value={cliente.usocfdi}
              onChange={handleChange}
            >
              <option value="">Selecciona...</option>
              {options.usoCfdiOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.value} - {o.label}
                </option>
              ))}
            </select>
          </div>

          <div className="field-group">
            <label className="label">Método de Pago:</label>
            <select
              className="input"
              name="metodopago"
              value={cliente.metodopago}
              onChange={handleChange}
            >
              <option value="">Selecciona...</option>
              {options.metodoPagoOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.value} - {o.label}
                </option>
              ))}
            </select>
          </div>

          <div className="field-group">
            <label className="label">Clave Forma de Pago Complemento:</label>
            <select
              className="input"
              name="claveformapagoparacomplemento"
              value={cliente.claveformapagoparacomplemento}
              onChange={handleChange}
            >
              <option value="">Selecciona...</option>
              {options.claveFormaPagoOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.value} - {o.label}
                </option>
              ))}
            </select>
          </div>

          <div className="field-group">
            <label className="label">Régimen:</label>
            <select
              className="input"
              name="Regimen"
              value={cliente.Regimen}
              onChange={handleChange}
            >
              <option value="">Selecciona...</option>
              {options.regimenOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.value} - {o.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <button type="submit" className="submit-button">
        Guardar
      </button>
    </form>
  );
};

export default ClienteForm;
